import { memo } from 'react';

import { useCallOrderTileId } from '@/App/tiles/orders/CallOrder/CallOrderCreationTile/CallOrderContext.tsx';
import { OrderSpot } from '@/App/tiles/orders/components/OrderSpot.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import { selectSpotCallOrderData } from '@/store/orders/call/selectors.ts';

export const ConnectedCallOrderSpot = memo(() => {
  const tileId = useCallOrderTileId();
  const spotDate = useAppSelector((state) => selectSpotCallOrderData(state, tileId));

  return <OrderSpot spotDate={spotDate} />;
});
